import { Inject, Injectable, Output, EventEmitter } from '@angular/core';
import { BaseEndpoint } from '../app.constants';
import { Headers, Http } from '@angular/http';
import { AdalService } from '../shared/azure-authentication/adal.service';
import { Reshuffle, PipelineLoanDto, ReshuffleResponse, LoanList } from './reshuffle';
import { User } from '../users/user.model';
import { LoanChannel, LoanPurpose } from '../loanprograms/loanprogram.model';

@Injectable()
export class UwAssignmentReshuffleService {

    constructor(private http: Http, @Inject(BaseEndpoint) private baseApiUrl: string, private adalService: AdalService) {
    }

    getLoanChannels(): Promise<LoanChannel[]> {
        const url = this.baseApiUrl + 'v1/loanchannels';
        return this.http
            .get(url, { headers: this.adalService.createServiceHeader() })
            .toPromise()
            .then(resp => {
                return resp.json().body;
            })
            .catch(this.handleError);
    }

    getLoanPurposes(): Promise<LoanPurpose[]> {
        const url = this.baseApiUrl + 'v1/loanpurposes';
        return this.http
            .get(url, { headers: this.adalService.createServiceHeader() })
            .toPromise()
            .then(resp => {
                return resp.json().body;
            })
            .catch(this.handleError);
    }

    getUnderwriters(persona: string): Promise<User[]> {
        const url = this.baseApiUrl + 'v1/users/persona';
        return this.http
            .get(url, { headers: this.adalService.createServiceHeader(), params: { persona } })
            .toPromise()
            .then(resp => {
                return resp.json().body;
            })
            .catch(this.handleError);
    }

    getLoanstoReshuffle(personaType: string, assignedDate: string, loanChannel: string, loanPurpose: string): Promise<PipelineLoanDto[]> {
        const url = this.baseApiUrl + 'v1/reshuffle';
        return this.http
            .get(url, { headers: this.adalService.createServiceHeader(), params: { personaType, assignedDate, loanChannel, loanPurpose } })
            .toPromise()
            .then(resp => {
                return resp.json().body;
            })
            .catch(this.handleError);
    }

    confirmReshuffle(loanNumbers: string[]): Promise<void> {
        const url = this.baseApiUrl + 'v1/reshuffle';
        return this.http
            .post(url, loanNumbers, { headers: this.adalService.createServiceHeader() })
            .toPromise()
            .then(resp => {
                return resp.json().body;
            })
            .catch(this.handleError);
    }

    makeUnderwriterLoansReshuffleAssignment(reshuffleDto: Reshuffle): Promise<ReshuffleResponse> {
        const url = this.baseApiUrl + 'v1/underwriterreshuffleassignments';
        return this.http
            .post(url, reshuffleDto, { headers: this.adalService.createServiceHeader() })
            .toPromise()
            .then(resp => {
                return resp.json();
            })
            .catch(this.handleError);
    }

    private handleError(errors: string[]): Promise<any> {
        console.error('An error occurred', errors);
        return Promise.reject(errors);
    }

    ResetLoansBacktoActive(loanNumbers: string[], assignedDate: Date) {
        const url = this.baseApiUrl + 'v1/ResetLoansBacktoActive';
        var loanList = new LoanList();
        loanList.AssignedDate = assignedDate.toDateString()
        // new Date((assignedDate.getMonth() + 1) + "/" + assignedDate.getDate() + "/" + assignedDate.getFullYear());
        loanList.LoanList = loanNumbers;

        return this.http
            .post(url, loanList, { headers: this.adalService.createServiceHeader() })
            .toPromise()
            .then(resp => {
                return resp.json().body;
            })
            .catch(this.handleError);
    }
}




// WEBPACK FOOTER //
// D:/a/1/s/Uhm.Loops.Web/src/app/uw-assignment-reshuffle/uw-assignment-reshuffle.service.ts